var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 44,
    viewBox: "0 0 164 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1063_8059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 164,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 0H0V44H164V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1063_8059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3251 42.756V34.1785H17.691L42.9268 1.21131H2.60162V9.78868H25.2357L0 42.756H40.3251ZM142.146 44C154.212 44 164 34.1458 164 22C164 9.85417 154.212 0 142.146 0C130.081 0 120.292 9.85417 120.292 22C120.292 34.1458 130.081 44 142.146 44ZM142.146 35.3244C134.862 35.3244 128.943 29.3661 128.943 22.0328C128.943 14.6994 134.862 8.74104 142.146 8.74104C149.431 8.74104 155.35 14.6994 155.35 22.0328C155.35 29.3661 149.431 35.3244 142.146 35.3244ZM117.854 42.7887L101.951 22.0328L117.854 1.27679H106.732L90.8293 22.0328L106.732 42.7887H117.854ZM86.016 42.7887V1.27679H76.3579V42.7887H86.016ZM52.3576 42.756V1.24405H62.0162V42.756H52.3576Z",
    fill: "#D7B46A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.70cad6c2a267e36e3c6644f4ebccad32.svg";
export { ForwardRef as ReactComponent };